<div class="sign-container">
  <div>
    <div style="width: 330px; height: 200px;">

      <canvas-whiteboard #canvasWhiteboard [options]="canvasOptions" [drawButtonClass]="'drawButtonClass'"
        [drawButtonText]="'Draw'" [clearButtonClass]="'clearButtonClass'" [clearButtonText]="'Clear'"
        [undoButtonText]="'Undo'" [undoButtonEnabled]="false" [redoButtonText]="'Redo'"
        [redoButtonEnabled]="false" [showShapeSelector]="false" [strokeColorPickerEnabled]="false"
        [fillColorPickerText]="'Filled'" [strokeColorPickerText]="'Stroked'" [colorPickerEnabled]="false"
        [strokeColorPickerEnabled]="false" [saveDataButtonEnabled]="false" [saveDataButtonText]="'Save'"
        [lineWidth]="5" [strokeColor]="'rgb(0,0,0)'" [shouldDownloadDrawing]="false" [class.sign-man-bor] = "message.length > 0" (onBatchUpdate)="sendBatchUpdate($event)">
      </canvas-whiteboard>
    </div>
    @if (drawingEnabled) {
      <img src="../../../../assets/css/images/platform/remove-file-gray@3x.png"
        (click)="canvasWhiteboardComponent.clearCanvas();drawn=false;" />
    }
  </div>
</div>

<p class="sign-error">{{message}}</p>

@if (btnEnabled) {
  <div class="btn-liner">
    <!--<input class="next-btn sign-btn" value="Podpiši" (click)="saveImg($event)" />-->
    <button type="button" class="next-btn sign-btn" (click)="saveImg($event)">Podpiši</button>
  </div>
}

<!--div class="loader-wrapper-sign">
<div class="loader"></div>
</div-->